/* eslint-disable no-undef */
/* global  */

import Isotope from '../../../node_modules/isotope-layout'
import matchesSelector from '../../../node_modules/desandro-matches-selector'
/* import header from '../../components/header'
import navMobile from '../../components/nav-mobile' */

let imagesCounter = 0
let imagesAmount = 0
let iso = {}
let filters = {}
let filterFns = {
  greaterThanZero: function (itemElem) {
    let area = itemElem.dataset.floor_area
    return parseInt(area, 10) <= 50
  },
  between50and100: function (itemElem) {
    let area = itemElem.dataset.floor_area
    return (parseInt(area, 10) <= 100 && parseInt(area, 10) > 50)
  },
  biggerThan100: function (itemElem) {
    let area = itemElem.dataset.floor_area
    return parseInt(area, 10) > 100
  }
}

// check if talomalligallery exists on the page
if (document.getElementById('taloMalliGallery') != null) {
  resetInputs()

  const images = document.querySelectorAll('.grid-item img')
  imagesAmount = images.length

  images.forEach(image => {
    if (image.complete) {
      incrementCounter()
    } else {
      image.addEventListener('load', incrementCounter, false)
    }
  })
}

function initIsotope () {
  // init Isotope
  iso = new Isotope('.grid', {
    itemSelector: '.grid-item',
    percentPosition: true,
    layoutMode: 'fitRows',
    filter: function (uselessInteger, itemElem2) {
      let isMatched = true
      for (let prop in filters) {
        let filter = filters[prop]
        // use function if it matches
        filter = filterFns[filter] || filter
        // test each filter
        let filterType = typeof filter
        if (filter.length > 0 && filterType === 'function') {
          isMatched = filter(itemElem2)
        } else if (filter.length > 0) {
          isMatched = matchesSelector(itemElem2, filter)
        }
        // break if not matched
        if (!isMatched) {
          break
        }
      }
      return isMatched
    }
  })
}

function initFilters () {
  // bind filter button click
  let filtersElem = document.querySelectorAll('.filters')
  let filtersSelectElem = document.querySelector('.filters-select')

  for (let i = 0; i < filtersElem.length; i++) {
    filtersElem[i].addEventListener('click', function (event) {
      // only work with buttons and inputs
      if (!matchesSelector(event.target, 'button') && !matchesSelector(event.target, 'input')) {
        return
      }
      let filterValues = []
      let filterGroup

      if (matchesSelector(event.target, 'button')) {
        // button
        filterGroup = event.target.parentNode.dataset.filter_group
        // adding is-checked returns true, removing it returns false
        const selected = buttonSelect(event.target)
        // check if button is chekced
        if (selected) {
          // add new filterValue
          // check if filter is already defined
          if (filters[filterGroup] === undefined) {
            filterValues.push(event.target.dataset.filter)
            filters[filterGroup] = filterValues
          } else {
            filters[filterGroup].push(event.target.dataset.filter)
          }
        } else {
          // remove filtervalue
          filters[filterGroup] = filters[filterGroup].filter(function (value) {
            return value !== event.target.dataset.filter
          })
        }
      } else {
        // radio input
        filterGroup = event.target.nextElementSibling.dataset.filter_group
        filterValues.push(event.target.dataset.filter)
        filters[filterGroup] = filterFns[filterValues] || filterValues
      }
      iso.arrange()
      /* console.log(filters) */
    })
  }

  // area select change-event
  filtersSelectElem.addEventListener('change', function (event) {
    let filterValue = event.target.value
    let filterGroup = event.target.dataset.filter_group
    filters[filterGroup] = filterFns[filterValue] || filterValue
    iso.arrange()
  })

  document.querySelector('.isotopeResetButton').addEventListener('click', function (event) {
    filters = {}
    iso.arrange()
    resetInputs()
  })
}

function buttonSelect (button) {
  if (button.classList.contains('is-checked')) {
    button.classList.remove('is-checked')
    return false
  } else {
    button.classList.add('is-checked')
    return true
  }
}

// reset gallery filter inputs
function resetInputs () {
  const purposeButtons = document.querySelectorAll('.button-group .button')

  // reset käyttötarkoitus
  purposeButtons.forEach(button => {
    if (button.classList.contains('is-checked')) {
      button.classList.remove('is-checked')
    }
  })

  const areaSelect = document.getElementById('area-select')

  // reset area-select
  areaSelect.childNodes.forEach(option => {
    if (option.selected && option.value) {
      option.selected = false
    }

    if (!option.value) {
      option.selected = true
    }
  })

  const floorButtons = document.getElementsByName('kerrosluku')

  // reset floor buttons
  floorButtons.forEach(radio => {
    if (radio.checked && radio.value !== '*') {
      radio.checked = false
    }

    if (radio.value === '*') {
      radio.checked = true
    }
  })

  const roomButtons = document.getElementsByName('rooms')

  // reset room buttons
  roomButtons.forEach(radio => {
    if (radio.checked && radio.value !== '*') {
      radio.checked = false
    }

    if (radio.value === '*') {
      radio.checked = true
    }
  })
}

function incrementCounter () {
  imagesCounter++
  if (imagesCounter === imagesAmount) {
    // init isotope and filters after all images have loaded
    initIsotope()
    initFilters()
  }
}

$(function () {
  $('.themebox.events .arrow-down').on('click', function () {
    // console.log('clicked')
    const eventsContainer = $(this).parent('.link-arrow').siblings('.events')
    // console.log(eventsContainer.height())
    // console.log(eventsContainer.scrollTop() + eventsContainer.height() - 30)
    eventsContainer.animate({
      scrollTop: eventsContainer.scrollTop() + eventsContainer.height() - 30
    })
  })
})

/* $(function () {
  // on page load hide header if using anchor link
  handleAnchorLinks()
  function handleAnchorLinks () {
    if (window.location.hash !== '') {
      let headroom
      // get headroom
      if ($(window).width() <= 767) {
        headroom = navMobile.getMobileHeadroom()
      } else {
        headroom = header.getHeadroom()
      }
      if (!$(window.location.hash).hasClass('active') && $(window.location.hash).hasClass('latest-news-container')) {
        const currentActive = $(window.location.hash).siblings('.active')
        slideNews(currentActive, $(window.location.hash))
      } else {
        // hide header
        headroom.unpin()
      }
    }
  }

  // handling clicking latest news
  $('.latest-news-container').on('click', function (event) {
    if ($(this).hasClass('active') && !$(event.target).hasClass('map-text')) {
      $(this).removeClass('active')
      $(this).children().slideToggle()
    } else if (!$(event.target).hasClass('map-text')) {
      const currentActive = $(this).siblings('.active')

      slideNews(currentActive, this)
    }
  })

  function slideNews (currentActive, thisNews) {
    let headroom
    // get headroom
    if ($(window).width() <= 767) {
      headroom = navMobile.getMobileHeadroom()
    } else {
      headroom = header.getHeadroom()
    }

    // hide headroom and prevent it from responding to scroll
    headroom.unpin()
    headroom.freeze()

    $(currentActive).children().slideToggle()
    $(currentActive).removeClass('active')
    $(thisNews).addClass('active')

    $(thisNews).children().slideToggle(400, function () {
      if ($(this).hasClass('latest-news')) {
        $('html, body').animate({
          // scroll to top of current news
          scrollTop: $(this).offset().top - 50
        }, {
          duration: 500,
          complete: function () {
            setTimeout(function () {
              // make headroom responsive to scroll again
              headroom.unfreeze()
            }, 700)
          }
        })
      }
    })
  }
}) */
